<template>
  <div>
    <!-- Menu de opções -->
    <div v-if="menuOptions.length > 0" class="div-fixed">
      <transition name="fade">
        <div v-if="showMenu" class="menu-options">
          <div
            v-for="(option, index) in menuOptions"
            :key="index"
            class="text-div-fixed"
            @click.stop="handleOptionClick(option)"
          >
            {{ option.label }}
          </div>
        </div>
      </transition>

      <v-btn
        v-if="menuOptions.length > 0"
        class="btn-guia-estudos"
        fab
        dark
        @click.stop="toggleMenu"
      >
        <img src="/img/sparkler.png" alt="Custom Icon" class="svg-icon" />
      </v-btn>
    </div>

    <LearningGuideDialog
      v-if="hasLearningGuideProps"
      ref="learningGuide"
      :course-id="parseInt(courseId)"
      :preparation-stage="parseInt(preparationStage)"
      @register-options="registerLearningGuideOptions"
    />

    <ChatDialog
      ref="chatDialog"
      v-if="Number.isFinite(courseId)"
      :is-guide-chat="isGuideChat"
      :course-id="parseInt(courseId)"
      @register-options="registerChatOptions"
    />
  </div>
</template>

<script>
import LearningGuideDialog from "../learningGuide/LearningGuideDialog.vue";
import ChatDialog from "../chat/ChatDialog.vue";

export default {
  name: "AITools",
  components: {
    LearningGuideDialog,
    ChatDialog,
  },
  props: {
    guideAssistant: {
      type: Object,
      default: null,
    },
    courseId: {
      type: Number,
      required: true,
    },
    preparationStage: {
      type: Number,
      default: null,
    },
    isGuideChat: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMenu: false,
      menuOptions: [],
      componentOptions: {
        learningGuide: [],
        chatDialog: [],
      },
    };
  },
  computed: {
    hasLearningGuideProps() {
      return (
        this.courseId !== null &&
        this.preparationStage !== null &&
        this.guideAssistant !== null
      );
    },
  },

  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    registerLearningGuideOptions(options) {
      this.componentOptions.learningGuide = options;
      this.updateMenuOptions();
    },
    registerChatOptions(options) {
      this.componentOptions.chatDialog = options;
      if (this.componentOptions.chatDialog.length > 0) {
        this.$emit("resourceAvailable", true);
      }
      this.updateMenuOptions();
    },
    updateMenuOptions() {
      this.menuOptions = [
        ...this.componentOptions.learningGuide,
        ...this.componentOptions.chatDialog,
      ].sort((a, b) => a.order - b.order);
    },
    handleOptionClick(option) {
      const component = this.$refs[option.component];
      if (component && typeof component[option.action] === "function") {
        component[option.action](...(option.params || []));
      }
      this.showMenu = false;
    },
    handleOptionClickFromShortcut() {
      let option = this.componentOptions.chatDialog[0];
      if (option) {
        const component = this.$refs[option.component];
        if (component && typeof component[option.action] === "function") {
          component[option.action](...(option.params || []));
        }
        this.showMenu = false;
      } else {
        console.log(">>> erro", this.menuOptions);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.div-fixed {
  position: fixed;
  bottom: 5%;
  right: 2%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15px;
}

.menu-options {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 15px;
}

.text-div-fixed {
  background: -webkit-linear-gradient(
    75deg,
    var(--v-primary-lighten2),
    var(--v-primary-lighten3)
  );
  border-radius: 9999px;
  padding: 3px 25px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
}

.svg-icon {
  width: 35px;
  height: 30px;
}

.btn-guia-estudos {
  background: -webkit-linear-gradient(
    58deg,
    var(--v-primary-base),
    var(--v-primary-lighten3)
  );
}

/* Animações para o menu */
.fade-enter-active,
.fade-leave-active {
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
